// extracted by mini-css-extract-plugin
export var content = "Content-module--content--3dNJJ";
export var content__list = "Content-module--content__list--2wUYt";
export var content__listItem = "Content-module--content__list-item--3GF7U";
export var content__title = "Content-module--content__title--2bVSe";
export var content__body = "Content-module--content__body--1YAIr";
export var paper = "Content-module--paper--3sQQ7";